import {Component, Inject, OnInit} from '@angular/core';
import {User} from "../../../shared/interface/user";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {UserService} from "../../../shared/services/user.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {catchError, mapTo, take, takeUntil, tap} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {of, ReplaySubject} from "rxjs";


export interface CrmUserPermissionsAddDialogData {
  user?: User;
}
@Component({
  selector: 'app-crm-user-permissions-add',
  templateUrl: './crm-user-permissions-add.component.html',
  styleUrls: ['./crm-user-permissions-add.component.scss']
})
export class CrmUserPermissionsAddComponent implements OnInit {

  crmUserPermissionsForm: FormGroup;
  partnerControl: FormControl;
  ofwcaControl: FormControl;
  userControl: FormControl;
  userObject: User;
  partnerOfwcaControl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private userService: UserService,
    public dialogRef: MatDialogRef<CrmUserPermissionsAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CrmUserPermissionsAddDialogData,
  ) {
    this.crmUserPermissionsForm = this.fb.group({
      partner: this.partnerControl = this.fb.control('',[Validators.required]),
      ofwca: this.ofwcaControl = this.fb.control(''),
      user: this.userControl = this.fb.control('', [Validators.required]),
      partnerOfwca: this.partnerOfwcaControl = this.fb.control(false),
    });
    this.userObject = data.user;
  }

  ngOnInit(): void {
    this.userControl.setValue(this.userObject.uuid);

    this.partnerOfwcaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        if (!val){
          this.partnerControl.reset();
          this.ofwcaControl.reset();
          this.ofwcaControl.clearValidators();
          this.partnerControl.setValidators([Validators.required]);
          this.ofwcaControl.disable();
          this.partnerControl.enable();
        }else{
          this.partnerControl.reset();
          this.ofwcaControl.reset();
          this.ofwcaControl.setValidators([Validators.required]);
          this.partnerControl.clearValidators();
          this.ofwcaControl.enable();
          this.partnerControl.disable();
        }
      });

  }

  closeDialog(): void {
    this.dialogRef.close();
  }


  sendForm(): void {
    this.userService.sendCrmUserPermissions(this.crmUserPermissionsForm.getRawValue())
      .pipe(
        tap((response: Uuid) => this.dialogRef.close(response.uuid)),
        mapTo('Pomyślnie utworzono uprawnienie '),
        catchError(() => {
          return of('Podczas tworzenia uprawnienia wystąpił błąd');
        })
      )
      .subscribe((message: string) => {
        this.snackBar.open(message, '', {
          duration: 2000,
        });
      });
  }
}
